const ItemsSchema = {
  title: 'Items (Semantic UI)',
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['items'],
    },
  ],

  properties: {
    items: {
      title: 'Items',
      widget: 'object_list',
      schema: {
        title: 'Item',
        fieldsets: [
          {
            id: 'default',
            title: 'Default',
            fields: [
              'image',
              'imageSize',
              'header',
              'link',
              'meta',
              'description',
              'extra',
            ],
          },
        ],
        properties: {
          image: {
            title: 'Image',
            type: 'string',
            widget: 'image',
          },
          imageSize: {
            title: 'Image size',
            type: 'choice',
            choices: [
              ['tiny', 'Tiny'],
              ['small', 'Small'],
              ['medium', 'Medium'],
              ['large', 'Large'],
              ['big', 'Big'],
            ],
            default: 'small',
          },
          header: {
            title: 'Header',
            type: 'string',
          },
          link: {
            title: 'Header Link',
            widget: 'object_browser',
            description: 'Adds an anchor tag to the header',
            mode: 'link',
            selectableTypes: ['Document'],
          },
          meta: {
            title: 'Meta',
            type: 'string',
            description: 'Adds gray text above the description'
          },
          description: {
            title: 'Description',
            widget: 'textarea',
            description: 'Supports paragraph-sized text'
          },
          extra: {
            title: 'Extra',
            widget: 'textarea',
            description: 'Adds light-gray text below the description'
          },
        },
        required: ['image', 'imageSize', 'header', 'description'],
      },
    },
  },

  required: ['items'],
};

export default ItemsSchema;
